import tracker from 'sanitas-tracking'

import packageInformation from '../../package.json'

const setTrackerVersion = () => {
  tracker.set({
    data: { _version: { fe: { com: packageInformation.version } } },
  })
}

const trackAction = rule => {
  tracker.trigger(tracker.triggerType.ACTION, rule)
}

const trackView = rule => {
  tracker.trigger(tracker.triggerType.VIEW_END, rule)
}

const trackForm = (formName, eventName, fieldName, errors) => {
  if (tracker.getHistory().find(h => h.event === eventName)) {
    return
  }

  let formData = tracker.get(`forms.com.${formName}`)

  if (!formData) {
    formData = []
  }

  const payload = {
    form: formName,
    fieldName,
    errors,
  }

  formData.push({
    name: payload.form,
    event: eventName,
    errors: payload.errors,
    fieldName: payload.fieldName,
  })

  tracker.set({ data: { forms: { com: { [formName]: formData } } } })
  tracker.trigger(tracker.triggerType.ACTION, eventName, false, payload)
}

export { setTrackerVersion, trackAction, tracker, trackForm, trackView }
